export default "__VITE_ASSET__Dzks7X9Z__"